import { baseTemplateParams } from '../shared/baseParams.js'

export const defaultTemplateParams = {
  ...baseTemplateParams,
  headerBgColor: '#ffffff',
  emailTitle: 'Confirm Your Subscription',
  ctaText: 'Confirm',
  ctaBackgroundColor: '#7a2c6f',
  ctaTextColor: '#ffffff',
  headerTaglineScript: 'Discover your next remarkable stay.',
  preheaderText: 'Confirm your subscription to stay inspired.',
  subject: 'Confirm your email subscription',
  selectedTemplate: 'welcomeSubscription',
  shellTemplateKey: 'welcomeSubscription',
  logoWidth: '150px',
  logoHeight: '60px',
  hotelName: '',
  hotelAddress: '',
  hotelCityStateZip: '',
  hotelPhone: '',
  hotelWebsite: '',
  hotelWebsiteUrl: '',
  richtextFields: {
    ...baseTemplateParams.richtextFields,
    bodyHtml: `Hello :token{key="guestName" label="First name"},

Thank you for your interest in our emails and newsletters. Click confirm below and let the adventure begin, with news, offers, and stories delivered straight to your inbox.

Have a question or need a hand? Reach out anytime — we are happy to help.`
  }
}

export default defaultTemplateParams
